var _ref;
function cov_1fq5s8f7m3() {
  var path = "/app/src/utils/datadog/constants.ts";
  var hash = "553ec3297c3c1b46faec4edd4d953f559cbbd0e3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/datadog/constants.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 25
        },
        end: {
          line: 3,
          column: 74
        }
      },
      "1": {
        start: {
          line: 5,
          column: 21
        },
        end: {
          line: 10,
          column: 11
        }
      },
      "2": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 12,
          column: 50
        }
      },
      "3": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 60
        }
      },
      "4": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 61
        }
      },
      "5": {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 15,
          column: 72
        }
      }
    },
    fnMap: {},
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 15,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 51
          },
          end: {
            line: 15,
            column: 64
          }
        }, {
          start: {
            line: 15,
            column: 68
          },
          end: {
            line: 15,
            column: 70
          }
        }],
        line: 15
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {},
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "553ec3297c3c1b46faec4edd4d953f559cbbd0e3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1fq5s8f7m3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1fq5s8f7m3();
import { DD_CLIENT_KEY, ENV, TAG } from 'src/constants/env';
var LOGGING_ENDPOINT = (cov_1fq5s8f7m3().s[0]++, 'https://browser-intake-datadoghq.eu/api/v2/logs');
var DEFAULT_TAGS = (cov_1fq5s8f7m3().s[1]++, ["env:".concat(ENV), "version:".concat(String(TAG).split('-')[0]), 'service:widget-integrations', 'api:fetch-keepalive'].join(','));
var DATADOG_BASE_URL = (cov_1fq5s8f7m3().s[2]++, new URL(LOGGING_ENDPOINT));
cov_1fq5s8f7m3().s[3]++;
DATADOG_BASE_URL.searchParams.append('ddsource', 'browser');
cov_1fq5s8f7m3().s[4]++;
DATADOG_BASE_URL.searchParams.append('ddtags', DEFAULT_TAGS);
cov_1fq5s8f7m3().s[5]++;
DATADOG_BASE_URL.searchParams.append('dd-api-key', (_ref = (cov_1fq5s8f7m3().b[0][0]++, DD_CLIENT_KEY)) !== null && _ref !== void 0 ? _ref : (cov_1fq5s8f7m3().b[0][1]++, ''));
export { DATADOG_BASE_URL, DEFAULT_TAGS };